import React from "react";
import {Typography, Grid, Paper, Alert} from "@mui/material";
import Lottie from "react-lottie";
import checkmark from "assets/animations/Checkmark.json";

import { StatusContainer, StatusRow, BikeDetails, BikeImage, StatusBox, StyledButton } from "./styles";
import {useCustomer} from "context/customer/customerContext";

/**
 *
 */
function TurnInStatus() {
  const {deliveryOption} = useCustomer();
  return (
    <Grid sx={{
      margin: "25px 0",
      minWidth: {
        xs: "100%", // Extra-small screens
        sm: "400px", // Small screens
        md: "600px", // Medium screens
        lg: "800px", // Large screens
      },
    }} container spacing={2} justifyContent="center" alignItems="start" style={{ margin: "25px 0"}}>
      <Paper elevation={3} style={{ padding: "15px", margin: "0 0", maxWidth: "600px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              Inspection complete
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Lottie width={100} height={100} options={{
              loop: false,
              autoplay: true,
              animationData: checkmark,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            }}/>
          </Grid>
          <Grid item xs={12}>
            {deliveryOption === "pickup" ?
              <Alert
                severity="success"
                variant="outlined"
                sx={{ borderRadius: "8px" }} // Adjust if necessary
              >
                <Typography variant="body1" gutterBottom style={{textAlign: "center"}}>
                  Your inspection has been completed! Our transport department will contact you shortly regarding your request for pick-up.  Have questions? Contact us at 800-717-3450.
                </Typography>
                <Typography variant="body1" gutterBottom style={{textAlign: "center"}}>
                  Please remove all personal belongings from their vehicle prior to returning it. Harley Davidson or it’s vendors are not responsible for any items left inside the vehicle, including but not limited to personal effects, valuables, or documents. By returning the vehicle, you acknowledge that you assume the risk of damage or loss to any personal property still left in the bike and will be responsible for any costs associated with the return if any personal property, if it can be returned. Please take a moment to thoroughly check all compartments to ensure that no items are inadvertently left behind.
                </Typography>
              </Alert> : <Alert
                severity="success"
                variant="outlined"
                sx={{ borderRadius: "8px" }} // Adjust if necessary
              >
                <Typography variant="body1" gutterBottom style={{textAlign: "center"}}>
                  Your pre-inspection has been completed! Please contact your authorized Flex Financing H-D Dealership to schedule your return.  Have questions? Contact us at 800-717-3450.
                </Typography>
                <Typography variant="body1" gutterBottom style={{textAlign: "center"}}>
                  Please remove all personal belongings from their vehicle prior to returning it. Harley Davidson or it’s vendors are not responsible for any items left inside the vehicle, including but not limited to personal effects, valuables, or documents. By returning the vehicle, you acknowledge that you assume the risk of damage or loss to any personal property still left in the bike and will be responsible for any costs associated with the return if any personal property, if it can be returned. Please take a moment to thoroughly check all compartments to ensure that no items are inadvertently left behind.
                </Typography>
              </Alert>}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

export default TurnInStatus;
